<template>
  <component :is="type">
    <i v-if="!disabled" class="fa fa-trash fa-danger fa-lg" @click="onShowModal" />
    <i v-else class="fa fa-trash fa-disabled fa-lg" />
    <Modal ref="deleteModal" @onClose="closeModal" :values="{ id: 'delete_modal' }" :noCloseOnBackdrop="false">
      <template slot="title">
        {{ titleTxt || $t('global.delete_title') }}
      </template>
      <template slot="body">
        {{ bodyTxt || $t('global.delete_confirm_text') }}
      </template>
      <template slot="footer">
        <b-button variant="danger" data-dismiss="modal" :disabled="isDeleting" @click='onDelete()'>
          <b-spinner v-if="isDeleting" type="grow" small />{{ deleteBtnTxt || $t('global.delete') }}</b-button>
        <b-button variant="info" @click="closeModal()" class="ml-2">{{ cancelTxt || $tk('global.cancel') }}</b-button>
      </template>
    </Modal>
  </component>
</template>

<script>
import Modal from '@/views/Shared/Modal';

export default {
  mounted() { },
  props: {
    id: {
      value: String,
      required: true
    },
    type: {
      value: String,
      default: 'div'
    },
    disabled: {
      value: String,
      required: false,
    },
    deleteBtnTxt: { // This will override translation key if passed
      value: String,
      default: undefined,
    },
    cancelTxt: { // This will override translation key if passed
      value: String,
      default: undefined,
    },
    titleTxt: {
      value: String,
      default: undefined, // default is = $t('global.delete_title')
    },
    bodyTxt: {
      value: String,
      default: undefined, // default is = $t('global.delete_confirm_text')
    },
    // be careful when passing function (it might execute if not passed as :deleteFn="()=>deleteSmth(row.id)" )
    deleteFn: {
      value: Function,
      default() { return Promise.resolve(); }
    },
  },
  data() {
    return {
      isDeleting: false,
    };
  },
  components: { Modal },
  computed: {},
  methods: {
    onShowModal() {
      this.$refs.deleteModal.show();
    },
    closeModal() {
      this.$refs.deleteModal.hide();
    },
    onDelete() {
      this.isDeleting = true;
      this.deleteFn().then(() => {
        this.alertSuccess();
        this.closeModal();
        this.$emit('deleted');
      }).catch(() => {
        this.$emit('failed');
        this.alertError();
      }).finally(() => {
        this.isDeleting = false;
      });
    },
  }
};

</script>

<style scoped></style>
